module.exports = __webpack_public_path__ + "static/img/18.8ad3cbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/18.jpg
// module id = Knzn
// module chunks = 1